import React from 'react';
import Icon from 'components/Theme/images/GDC-App-website-blue.svg';

const GDCWebsiteIcon = ({
  alt,
  style,
}: Object): React.Element => (
  <img
    alt={alt}
    className="icon icon-gdc-data-portal"
    src={Icon}
    style={style}
    />
);

export default GDCWebsiteIcon;
